(function() { module.exports = window["Next"]["Select"]; }());